module.exports = __webpack_public_path__ + "e0de455073fcd389052034d7bdf4b485.svg";